/**
 * External dependencies
 */
import styled from '@emotion/styled';

/**
 * WordPress dependencies
 */
import {
	Button,
	HStack,
	UnitControl,
	RangeControl,
} from '@safe-wordpress/components';

/**
 * Internal dependencies
 */
import BoxControlIcon from '../icon';
import { space } from '../../utils';

export const StyledUnitControl = styled( UnitControl )`
	max-width: 90px;
`;

export const InputWrapper = styled( HStack )`
	grid-column: 1 / span 3;
`;

export const ResetButton = styled( Button )`
	grid-area: 1 / 2;
	justify-self: end;
`;

export const LinkedButtonWrapper = styled.div`
	grid-area: 1 / 3;
	justify-self: end;
`;

export const FlexedBoxControlIcon = styled( BoxControlIcon )`
	flex: 0 0 auto;
`;

export const FlexedRangeControl = styled( RangeControl )`
	width: 100%;
	margin-inline-end: ${ space( 2 ) };
`;
